import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tekman-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit {
  @Input() text: string;

  ngOnInit(): void {
    this.checkRequired();
  }

  checkRequired() {
    if (!this.text) {
      throw new Error('Text tooltip is required');
    }
  }
}
